import { privateApi } from 'services';
import { MetaConnectionItem, CreateMetaConnectionItem, EditMetaConnectionItem } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchMetaConnectionItems = (businessAccountId: string): Promise<MetaConnectionItem[]> =>
    privateApi.get<MetaConnectionItem[]>(`business-accounts/${businessAccountId}/meta-connections`);

const createMetaConnectionItem = (
    businessAccountId: string,
    metaConnection: CreateMetaConnectionItem,
): Promise<MetaConnectionItem> =>
    privateApi.post<MetaConnectionItem>(`business-accounts/${businessAccountId}/meta-connections`, metaConnection);

const updateMetaConnectionItem = (
    metaConnectionId: string,
    metaConnectionItem: EditMetaConnectionItem,
): Promise<MetaConnectionItem> =>
    privateApi.put<MetaConnectionItem>(`meta-connections/${metaConnectionId}`, metaConnectionItem);

export const MetaConnectionItemGateway = {
    fetchMetaConnectionItems,
    createMetaConnectionItem,
    updateMetaConnectionItem,
};

const cancelableFetchMetaConnectionItems = (businessAccountId: string): Promise<MetaConnectionItem[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<MetaConnectionItem[]>(
        `business-accounts/${businessAccountId}/meta-connections`,
    );

export const CancelableMetaConnectionItemGateway = {
    cancelableFetchMetaConnectionItems,
};
